import type { App } from 'vue';
import { markRaw, readonly } from 'vue';

import { PLUGIN_KEY } from './providers';
import { createState } from './state';
import type { PluginOptions, ToastMessagesPlugin } from './types';

export function createToastMessagesPlugin(options?: PluginOptions): ToastMessagesPlugin {
  const state = createState();

  const config = readonly({
    timeOut: 3000,
    ...options,
  });

  return markRaw({
    config,

    state: readonly(state),

    addSuccessMessage: (message) => {
      state.addMessage({
        content: message.content,
        timeOut: message.timeOut || config.timeOut,
        leadingIcon: message.leadingIcon,
        variant: 'default',
      });
    },

    addErrorMessage: (message) => {
      state.addMessage({
        content: message.content,
        timeOut: message.timeOut || config.timeOut,
        leadingIcon: message.leadingIcon,
        variant: 'error',
      });
    },

    install(app: App): void {
      app.provide(PLUGIN_KEY, this);
      app.config.globalProperties['$toastMessages'] = this;
    },
  });
}
